import { Mod, ModState } from "../../Mod/types/mod";
import { WorkshopItem } from "../types/workshopItem";

export const workshopItemToMod = (item: WorkshopItem): Mod => ({
	id: item.publishedFileId,
	state: ModState.Downloading,
	title: item.title,
	updateDate: new Date(item.timeUpdated * 1000),
	workshopUpdateDate: new Date(item.timeUpdated * 1000),
	postedDate: new Date(item.timeCreated * 1000),
	reportedSize: parseInt(item.fileSize, 10),
	image: item.previewUrl,
	tags: item.tags,
});
